<template>
    <div class="row survey" style="width: 100%" v-show="sortedRecords.length > 0">
        <span class="headerText">This record is currently being used in the following {{ recordType }}</span>
        <table class="listing">
        <thead>
            <tr>
                <th>Name</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(row, rowIndex)  in records" :key="rowIndex">
                <td>
                    <a class="link" v-if="editPage" :href="'/' + editPage + '?ID=' + row.id">{{ row[sortFieldName] }}</a>
                    <span v-if="!editPage">{{ row[sortFieldName] }}</span>
                    <span class="inactiveFlag" v-if="row.isActive != null && !row.isActive">(Inactive)</span>
                </td>
            </tr>
        </tbody>
        </table>
    </div>
</template>

<script>

export default {
    name: 'FKLookupListing',
    props: {
        recordType: {
            type: String
        },
        editPage: {
            type: String
        },
        sortFieldName: {
            type: String,
            default: "name"
        },
        onLoadData: {
          type: Function
        },
    },
    data: function() {
        return {
            item: {},
            records: []
        }
    },
    computed: {
        sortedRecords () {
            var sortedRecords = this.records;
            sortedRecords.sort(this.compareValues(this.sortFieldName, "asc"));
            return sortedRecords;
        },
    },
    mounted() {
        this.getRecords();
    },
    methods: {
        getRecords: async function() {
            if(this.onLoadData) {
                this.records = await this.onLoadData();
            }
        },
        compareValues: function(key, order = 'asc') {
            return function innerSort(a, b) {
                const varA = (typeof a[key] === 'string')
                    ? a[key].toUpperCase() : a[key];
                const varB = (typeof b[key] === 'string')
                    ? b[key].toUpperCase() : b[key];

                let comparison = 0;
                if (varA > varB) {
                    comparison = 1;
                } 
                else if (varA < varB) {
                    comparison = -1;
                }

                return ( (order === 'desc') ? (comparison * -1) : comparison );
            };
        },
    }
}
</script>

<style scoped>
table.listing {
    border-collapse:collapse;
    border:1px solid #2F2F52 ;
    width: 100%;
}

table.listing th {
    border:1px solid #2F2F52 ;
    padding-left: 15px;
    background: #9E9E9E;
}

table.listing tbody tr:nth-child(even) {
      background-color: #f3f3f3;
}
table.listing td {
    border:1px solid #2F2F52 ;  
    padding: 5px 5px 5px 15px;
    text-align: left;
    font: 12px/14px sans-serif;
}

span.headerText {
    color: #8B4000;
    font: 12px/14px sans-serif;
    font-weight: bold;
    
}

.link {
    cursor: pointer;
    text-decoration: underline;
    color: #0096FF;
    font-weight: bold;
}

.inactiveFlag {
    color: darkred;
    font-weight: bold;
    float: right;
}

</style>